/* eslint-disable flowtype/require-valid-file-annotation */
import React, { Component } from 'react';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import wrapDisplayName from 'recompose/wrapDisplayName';
import getContext from './themeContext';

const context = getContext();

// Apply some reset
const styles = theme => ({
  '@global': {
    html: {
      WebkitFontSmoothing: 'antialiased', // Antialiasing.
      MozOsxFontSmoothing: 'grayscale', // Antialiasing.
      // Change from `box-sizing: content-box` so that `width`
      // is not affected by `padding` or `border`.
      boxSizing: 'border-box',
    },
    '*, *::before, *::after': {
      boxSizing: 'inherit',
    },
    body: {
      margin: 0, // Remove the margin in all browsers.
      backgroundColor: theme.palette.common.white,
    },
  },
});

let AppWrapper = props => props.children;
AppWrapper = withStyles(styles)(AppWrapper);

function withRoot(BaseComponent) {
    class WithRoot extends Component {
        constructor(props) {
            super(props, context);
        }

        componentDidMount() {
            // Remove the server-side injected CSS.
            const jssStyles = document.querySelector('#jss-server-side');
            if (jssStyles && jssStyles.parentNode) {
                jssStyles.parentNode.removeChild(jssStyles);
            }
        }

        render() {
            return (
                    <MuiThemeProvider
                        theme={context.theme}
                        sheetsManager={new WeakMap()}
                    >
                        <AppWrapper>
                            <BaseComponent {...this.props} />
                        </AppWrapper>
                    </MuiThemeProvider>
            );
        }
  }

    WithRoot.getInitialProps = ctx => {
        if (Component.getInitialProps) {
            return Component.getInitialProps(ctx);
        }
        return {};
    };

    if (process.env.NODE_ENV !== 'production') {
        WithRoot.displayName = wrapDisplayName(BaseComponent, 'withRoot');
    }

    return WithRoot;
}

export default withRoot;



// WEBPACK FOOTER //
// ./src/themeHOC.js